var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_200)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4925 28.3692L27.9966 8L15.4973 28.3709L27.9966 35.6274L40.4925 28.3692ZM40.5025 30.6981L27.9966 37.9512L15.4973 30.6997L27.9966 48L40.5025 30.6981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9958 8V22.7864L40.4934 28.3709L27.9958 8ZM27.9958 37.9529V48L40.5018 30.6981L27.9958 37.9529Z",
    fill: "#C0CBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9958 35.6275L40.4934 28.371L27.9958 22.7898V35.6275Z",
    fill: "#8197EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4973 28.371L27.9966 35.6275V22.7898L15.4973 28.371Z",
    fill: "#C0CBF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.82eec1a8e4a1d1d1e0c252f6f6a6c2b2.svg";
export { ForwardRef as ReactComponent };